import getCsrftoken from './getCsrftoken';

const fetchInit = (body) => {
  const ret = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      'X-CSRFToken': getCsrftoken(),
    },
    credentials: 'same-origin',
  };

  if (body != null) {
    Object.assign(ret, {body});
  } else {
    Object.assign(ret, {body: JSON.stringify({})});
  }

  return ret;
};

export default fetchInit;
